import { render, staticRenderFns } from "./PrestationPrice.vue?vue&type=template&id=361d9334"
import script from "./PrestationPrice.vue?vue&type=script&lang=js"
export * from "./PrestationPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports